module.exports = __webpack_public_path__ + "img/flagmidias.39850f1d.jpeg";